import { render, staticRenderFns } from "./NuevoCambioSIM.vue?vue&type=template&id=6d861074&"
import script from "./NuevoCambioSIM.vue?vue&type=script&lang=ts&"
export * from "./NuevoCambioSIM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6d861074', component.options)
    } else {
      api.reload('6d861074', component.options)
    }
    module.hot.accept("./NuevoCambioSIM.vue?vue&type=template&id=6d861074&", function () {
      api.rerender('6d861074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/CambiosServicio/NuevoCambioSIM.vue"
export default component.exports